import { render, staticRenderFns } from "./DomainsSelector.vue?vue&type=template&id=01014860"
import script from "./DomainsSelector.vue?vue&type=script&lang=js"
export * from "./DomainsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports